<template>
  <div id="przewodnik-turystyczny">
    <T1HeadScripts />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content>
          <T1PrzewodnikTurystycznyContent />
        </a-layout-content>
      </div>
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1PrzewodnikTurystycznyContent from "./components/T1PrzewodnikTurystycznyContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "przewodnik-turystyczny",
  data: () => ({}),
  methods: {},
  mounted() {},
  components: {
    T1HeadScripts,
    T1Header,
    T1PrzewodnikTurystycznyContent,
    T1Footer
  }
};
</script>
